export { default } from "./clamp.mjs";